import { render, staticRenderFns } from "./SelectPayType.vue?vue&type=template&id=7ddee86c&lang=pug"
import script from "./SelectPayType.vue?vue&type=script&lang=js"
export * from "./SelectPayType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports